import { ValidationError } from '@/models/ValidationError';
import { ISubmissionState } from '@/modules/submission/store/state';
import { IRootState } from '@/store/state';
import { GetterTree } from 'vuex';

/**
 * --------------------------------------------------
 *	Submission Getters
 * --------------------------------------------------
 **/
export const SubmissionGetters: ISubmissionGetters = {
  getSubmissionErrors: (state: ISubmissionState) => (submissionId: string) =>
    state.errors[submissionId]
};

/**
 * --------------------------------------------------
 *	Submission Getters Interface
 * --------------------------------------------------
 **/
export interface ISubmissionGetters
  extends GetterTree<ISubmissionState, IRootState> {
  getSubmissionErrors(
    state: ISubmissionState
  ): (submissionId: string) => ValidationError[];
}
